/**
 * OAuth 成功後の遷移先。`callbackURL: '/'` だけだと相対扱いされ API の baseURL（例: :8088）基準に解決される。
 * admin の絶対 URL（末尾 `/`）を返す。
 */
export function getAuthAfterLoginUrl(): string {
  const fromEnv = import.meta.env.VITE_ADMIN_BASE_URL?.trim();
  if (fromEnv) {
    return fromEnv.endsWith("/") ? fromEnv : `${fromEnv}/`;
  }
  if (typeof window !== "undefined") {
    return `${window.location.origin}/`;
  }
  return "http://localhost:5173/";
}
